module.exports = __webpack_public_path__ + "media/application/images/img/overlays/09-fd19309a1932b475138799acc0b75a82.png";